<script>
export default {
  name: 'ProductFormDimensionsStep',
  props: {
    form: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    rules() {
      const { length, height, depth, unit } = this.form.dimensions
      const dimensionRequired = !!length || !!height || !!depth || !!unit
      const { value: weightVal, unit: weightUnit } = this.form.weight
      const weightRequired = !!weightVal || !!weightUnit

      return {
        'dimensions.unit': [
          {
            required: dimensionRequired,
            message: 'This field is required',
            trigger: 'blur',
          },
        ],
        'dimensions.length': [
          {
            required: dimensionRequired,
            message: 'This field is required',
            trigger: 'blur',
          },
        ],
        'dimensions.height': [
          {
            required: dimensionRequired,
            message: 'This field is required',
            trigger: 'blur',
          },
        ],
        'dimensions.depth': [
          {
            required: dimensionRequired,
            message: 'This field is required',
            trigger: 'blur',
          },
        ],
        'weight.value': [
          {
            required: weightRequired,
            message: 'This field is required',
            trigger: 'blur',
          },
        ],
        'weight.unit': [
          {
            required: weightRequired,
            message: 'This field is required',
            trigger: 'blur',
          },
        ],
      }
    },
  },
  methods: {
    changeValue(field, value) {
      console.warn({ field, value })
      this.$emit('change', { field, value })
    },
    inputAppend(val) {
      return val ? val.toUpperCase() : '-'
    },
  },
}
</script>

<template>
  <div>
    <el-form
      class="modal-form"
      label-position="top"
      :model="form"
      :rules="rules"
      :validate-on-rule-change="false"
    >
      <div class="united-field">
        <el-form-item
          label="Dimensions Unit"
          prop="dimensions.unit"
        >
          <el-select
            :value="form.dimensions.unit"
            @input="changeValue('dimensions.unit', $event)"
          >
            <el-option
              :value="null"
              label="None"
            />
            <el-option
              value="in"
              label="in - Inches"
            />
            <el-option
              value="cm"
              label="cm - Centimeters"
            />
          </el-select>
        </el-form-item>

        <el-form-item
          label="Length"
          prop="dimensions.length"
        >
          <el-input
            type="number"
            placeholder="Enter length"
            :value="form.dimensions.length"
            @input="changeValue('dimensions.length', $event)"
          >
            <template
              #append
            >
              {{ inputAppend(form.dimensions.unit) }}
            </template>
          </el-input>
        </el-form-item>
      </div>

      <div class="united-field">
        <el-form-item
          label="Height"
          prop="dimensions.height"
        >
          <el-input
            type="number"
            placeholder="Enter height"
            :value="form.dimensions.height"
            @input="changeValue('dimensions.height', $event)"
          >
            <template
              #append
            >
              {{ inputAppend(form.dimensions.unit) }}
            </template>
          </el-input>
        </el-form-item>

        <el-form-item
          label="Depth"
          prop="dimensions.depth"
        >
          <el-input
            type="number"
            placeholder="Enter depth"
            :value="form.dimensions.depth"
            @input="changeValue('dimensions.depth', $event)"
          >
            <template
              #append
            >
              {{ inputAppend(form.dimensions.unit) }}
            </template>
          </el-input>
        </el-form-item>
      </div>

      <div class="united-field">
        <el-form-item
          label="Weight Unit"
          prop="weight.unit"
        >
          <el-select
            :value="form.weight.unit"
            @input="changeValue('weight.unit', $event)"
          >
            <el-option
              :value="null"
              label="None"
            />
            <el-option
              value="kg"
              label="kg - Kilograms"
            />
            <el-option
              value="lb"
              label="lb - Pounds"
            />
          </el-select>
        </el-form-item>

        <el-form-item
          label="Weight"
          prop="weight.value"
        >
          <el-input
            type="number"
            placeholder="Enter weight"
            :value="form.weight.value"
            @input="changeValue('weight.value', $event)"
          >
            <template
              #append
            >
              {{ inputAppend(form.weight.unit) }}
            </template>
          </el-input>
        </el-form-item>
      </div>
    </el-form>
  </div>
</template>
